import { inject, provideAppInitializer } from '@angular/core';

import { KgwConfigService } from '../services';

export const KGW_CONFIG_PROVIDER = [
  provideAppInitializer(() => {
    const kgwConfigService = inject(KgwConfigService);

    return kgwConfigService.loadKgwConfig$();
  }),
];
